import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { getFeaturedMovies } from "@/mocks/movies";

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const featured = getFeaturedMovies();
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const next = () => setCurrent((prev) => (prev + 1) % featured.length);
  const prev = () => setCurrent((prev) => (prev - 1 + featured.length) % featured.length);

  useEffect(() => {
    intervalRef.current = setInterval(next, 5000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  if (featured.length === 0) return null;

  const movie = featured[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={movie.detailImage}
          alt={movie.title}
          title={`${movie.title} - 酷客影院精选推荐`}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-background-50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-transparent"></div>
      </div>

      <div className="absolute inset-0 flex items-center">
        <div className="px-4 md:px-6 w-full max-w-screen-2xl mx-auto">
          <div className="max-w-lg md:max-w-xl">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xs px-2.5 py-1 rounded-full bg-accent-500 text-white font-medium whitespace-nowrap">
                精选推荐
              </span>
              <span className="text-xs px-2.5 py-1 rounded-full bg-white/20 text-white backdrop-blur-sm whitespace-nowrap">
                {movie.category}
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-3 leading-tight">
              {movie.title}
            </h2>
            <p className="text-white/80 text-sm md:text-base mb-6 line-clamp-2 max-w-md">
              {movie.summary}
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              <Link
                to={`/detail/${movie.id}`}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <i className="ri-play-fill text-lg"></i>
                立即观看
              </Link>
              <span className="text-white/60 text-sm">
                <i className="ri-star-fill text-accent-400 mr-1"></i>
                {movie.rating}
              </span>
              <span className="text-white/60 text-sm">{movie.duration}</span>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/25 backdrop-blur-sm text-white transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/25 backdrop-blur-sm text-white transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {featured.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              i === current ? "bg-white w-6" : "bg-white/40 hover:bg-white/70"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}